module.exports = __webpack_public_path__ + "img/virtualis-modellezes.71dd0ad7.jpg";